import React, { useState, useEffect, useRef } from "react";
import "../styles/SuccessNumbers.css";
import { FaGlobe, FaUsers, FaShippingFast, FaHistory } from "react-icons/fa";
import bgImage from "../assets/images/00bg.webp"; // 🔹 background image path

// A small counter hook: counts from 0 → target when visible
function useCountOnView(target, duration, trigger) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!trigger) return;           // only animate when section is visible
    let start = 0;
    const step = target / (duration / 16); // 16ms ~ 60fps

    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        clearInterval(timer);
        setCount(target);
      } else {
        setCount(Math.ceil(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [target, duration, trigger]);

  return count;
}

export default function SuccessNumbers() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer: detect when section enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setVisible(true);
          else setVisible(false); // 👈 when leaving viewport reset trigger
        });
      },
      { threshold: 0.4 } // 40% visible
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Counters
  const countries = useCountOnView(30, 2000, visible);   // 30+ Countries
  const clients   = useCountOnView(50, 2000, visible);  // 120+ Clients
  const offices   = useCountOnView(500, 2000, visible);   // 15+ Offices
  const awards    = useCountOnView(10, 2000, visible);   // 25+ Awards

  return (
    <section
      className="success-section"
      ref={sectionRef}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay">
        <h2>Success Numbers</h2>
        <p>
          We are proud of our global reach and the trust of our partners.
          <br />
          These numbers continue to grow every year.
        </p>

        <div className="cards">
          <div className="card">
            <FaGlobe className="icon" />
            <h3>{countries}+</h3>
            <p>Countries</p>
          </div>

          <div className="card">
            <FaUsers className="icon" />
            <h3>{clients}+</h3>
            <p>Happy Clients</p>
          </div>

          <div className="card">
            <FaShippingFast className="icon" />
            <h3>{offices}+</h3>
            <p>Product Types Traded</p>
          </div>

          <div className="card">
            <FaHistory className="icon" />
            <h3>{awards}+</h3>
            <p>Years Experience</p>
          </div>
        </div>
      </div>
    </section>
  );
}
